import script from "./Promocao.vue?vue&type=script&setup=true&lang=js"
export * from "./Promocao.vue?vue&type=script&setup=true&lang=js"

import "./Promocao.vue?vue&type=style&index=0&id=9e32535c&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9e32535c"]])

export default __exports__